/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup  } from 'react-leaflet'
import PageHeader from 'components/common/PageHeader';
import DefaultCard from 'components/mycomponents/DefaultCard';
import ModalAlert from 'components/mycomponents/ModalAlert';
import Select from 'react-select';
import { Icon } from 'leaflet';
import axios from 'api/axios';

import 'assets/scss/map.scss'
import { Col, Row } from 'react-bootstrap';

const VehicleTracking = () => {

    // Declare state variable
    const [data, setData] = useState(null);
    const [defaultLongLat, setDefaultLongLat] = useState([-6.883729232769789, 112.04522597619037]);
    const [dataList, setDataList] = useState({vehicle: null});
    const [dataListSelected, setDataListSelected] = useState({vehicle: null});
    const [showAlert, setShowAlert] = useState({show: false, message: '', type: '', confirmButton: false});


    // Declare Variable
    const DATA_URL = '/vehicles';
    const DATA_URL_LIST = '/lists';
    const ACCESS_USER = JSON.parse(localStorage.getItem('accessUser'));
    const TOKEN_APP = ACCESS_USER ? ACCESS_USER.token : '';
    const HEADER_AUTHORIZATION = {
        headers: {
          'Authorization': `Bearer ${TOKEN_APP}`
        }
    };
    const customIcon = new Icon({
        iconUrl: 'https://pohonmedia.com/assets/img/map.png',
        iconSize: [38,38]
    });

    const getVehicleData = async (intid = 0) => {
            try {
                const response = await axios.get(`${DATA_URL}/location?intid=${intid}`, {
                    headers: {
                      'Authorization': `Bearer ${ACCESS_USER.token}`
                    }
                  });
                const responseResult = response?.data;
                const responseData = responseResult?.data;
                setData(responseData);
                setDefaultLongLat([responseData[0].declattitude, responseData[0].declongitude])
            } catch (err) {
                // if (err.response) {
                //     const response = err.response.data;
                //     setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                // } else {
                //     setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
                // }
            }
        }

    useEffect(() => {
        getVehicleData()
    },[ACCESS_USER.token]);

    useEffect(() => {
            const getListVehicle = async () => {
                try {
                    const response = await axios.get(`${DATA_URL_LIST}/vehicle`, HEADER_AUTHORIZATION);
                    const responseResult = response?.data;
                    setDataList(prevState => { return {...prevState, vehicle: responseResult?.data} });
                } catch (err) {
                    if (err.response) {
                        const response = err.response.data;
                        setShowAlert(prevState => { return {...prevState, show: true, message: response.message, type: 'error'} })
                    } else {
                        setShowAlert(prevState => { return {...prevState, show: true, message: 'Something error with server. Please call administrator or developer.', type: 'error'} })
                    }
                }
            }
    
            getListVehicle()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const handleChangeFormSelect = (value, listName) => {
        setDataListSelected(prevState => {
            return {...prevState, [listName]: value};
        });
        getVehicleData(value.value);
    }

    const handleConfirmAlert = () => {
        setShowAlert(prevState => { return {...prevState, show: false}});
    }

    return (
        <>
            {/* Page Header */}
            <PageHeader
                title="Lacak Kendaraan"
                description=""
                className="mb-3"
            >
            </PageHeader>

            <DefaultCard>
                <DefaultCard.Body>
                    <Row>
                        <Col md={4} className="mb-3">
                            <Select
                                options={dataList.vehicle}
                                placeholder='Pilih Kendaraan'
                                classNamePrefix="react-select"
                                value={dataListSelected.vehicle}
                                onChange={(value) => handleChangeFormSelect(value, 'vehicle')}
                            />
                        </Col>
                    </Row>
                    <MapContainer center={defaultLongLat} zoom={14} scrollWheelZoom={false} style={{width:'100%', height: '100v'}}>
                        <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        {
                            data ? data.map((val, idx) => {
                                return (
                                    <Marker position={[val.declattitude,val.declongitude]} icon={customIcon} key={idx}>
                                        <Popup>
                                            {val.vcnama} <br /> {val.vcnopol}
                                        </Popup>
                                    </Marker>
                                );
                            }) : ''
                        }
                    </MapContainer>
                </DefaultCard.Body>
            </DefaultCard>

            <ModalAlert 
                type={showAlert.type}
                show={showAlert.show}
                message={showAlert.message}
                onHide={() => setShowAlert(prevState => { return {...prevState, show: false} })}
                onConfirm={handleConfirmAlert}
                confirmButton={showAlert.confirmButton}
            />
        </>
    )
}

VehicleTracking.propTypes = {}

export default VehicleTracking;